<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="importLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary tw-text-center">
                Import Batch
            </h2>
            <div class="pb-0">
                <v-form name="importBatchForm" ref="importBatchForm">

                    <div class="tw-flex tw-mb-2 tw-p-2">
                        <div class="tw-flex tw-flex-col tw-w-full tw-gap-3">
                            <v-text-field
                                v-model="batchData.conversion_rate"
                                label="Conversion Rate"
                                dense
                                type="number"
                                :error-messages="errors?.conversion_rate"
                                hide-details="auto"
                                clearable
                            ></v-text-field>
                            <date-picker
                                display-label="Deposit Date"
                                v-model="batchData.date_deposit"
                                show-adjacent-months
                                class="tw-w-full"
                                dense
                                :rules="[rules.required]"
                                :error-messages="errors?.date_deposit"
                                hide-details="auto"
                            />
                            <v-text-field
                                v-model="batchData.payer"
                                label="Payer"
                                dense
                                :rules="[rules.required]"
                                :error-messages="errors?.payer"
                                hide-details="auto"
                                clearable
                            ></v-text-field>
                            <v-select
                                label="Method"
                                :items="values_methods"
                                v-model="batchData.method"
                                dense
                                :rules="[rules.required]"
                                :error-messages="errors?.method"
                                hide-details="auto"
                                clearable
                            ></v-select>
                            <v-file-input
                                v-model="batchData.batch_file"
                                label="Batch File"
                                accept="text/csv"
                                dense
                                outlined
                                :prepend-icon="null"
                                :rules="[rules.required]"
                                :error-messages="errors?.batch_file"
                                hide-details="auto"
                            >
                            </v-file-input>
                        </div>
                    </div>
                </v-form>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">

                <v-btn
                    text
                    @click="cancelDialog"
                    class="btn-solid"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="requestImportBatch"
                    class="main-btn"
                    :loading="importLoading"
                >
                    Import
                </v-btn>

            </div>
        </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker.vue";
export default {
    name: "ImportBatchDialog",
    components: {DatePicker},
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
    },
    data() {
        return {
            dialog: this.value || false,
            importLoading: false,
            batchData: {
                conversion_rate: null,
                date_deposit: null,
                payer: null,
                method: null,
                batch_file: null,
            },
            batchDataDefault: {
                conversion_rate: null,
                date_deposit: new Date().toISOString().split('T')[0],
                payer: null,
                method: null,
                batch_file: null,
            },
            rules: {
                required: value => !!value || 'Required',
                number: value => !isNaN(value) || 'Must be a number'
            },
            errors: null,
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '450px'
        },
        values_methods() {
            if (this?.constants?.BATCH_METHODS) {
                return Object.values(this.constants?.BATCH_METHODS)
            }
            return []
        },
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        async requestImportBatch() {
            if (this.$refs.importBatchForm.validate()) {
                let formData = new FormData()

                for (let key in this.batchData) {
                    if (this.batchData[key] !== null
                        && this.batchData[key] !== undefined
                        && this.batchData[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.batchData[key])
                    } else {
                        formData.append(key, '')
                    }
                }

                let method = 'post'
                let url = route('batches.import')

                axios({
                    method: method,
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.importLoading = !this.importLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.importLoading = !this.importLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} once the import is done.`)
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.importLoading = false
                            this.$emit('successful-batch-import')
                        } else {
                            throw (response.data?.error || 'Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response?.data.message || error)
                        this.errors = error.response?.data?.errors
                        this.importLoading = false
                    })
            }
        }
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
            } else {
                this.batchData = _.clone(this.batchDataDefault);
            }
        },
    },
}

</script>

<style scoped>

</style>
